export const COVERAGE_LIMIT_ROUTE_PREFIX = "/settings/coverage-limits";

export const COVERAGE_LIMIT_ROUTE_PATHS = {
  list: { path: "*", to: COVERAGE_LIMIT_ROUTE_PREFIX },
};
